import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Header from '../components/Header';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ResetPasswordPage() {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 72, background: 'var(--bg-section)' }}>
        <div style={{ width: '100%', maxWidth: 440, padding: '0 24px' }}>
          <div style={{ background: 'white', border: '1px solid var(--border)', padding: '48px 40px' }}>
            {submitted ? (
              <div data-testid="reset-success" style={{ textAlign: 'center' }}>
                <div style={{ width: 56, height: 56, background: 'rgba(13,71,161,0.08)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                  <span style={{ fontSize: 24, color: 'var(--primary)' }}>&#9993;</span>
                </div>
                <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 24, fontWeight: 700, marginBottom: 12 }}>Check your email</h1>
                <p style={{ color: 'var(--text-secondary)', fontSize: 15, marginBottom: 24, lineHeight: 1.6 }}>
                  If an account exists for <strong>{email}</strong>, we've sent a password reset link.
                </p>
                <Link to="/login" style={{ color: 'var(--primary)', fontWeight: 600, fontSize: 14 }}>&larr; Back to login</Link>
              </div>
            ) : (
              <>
                <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 28, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 8 }}>{t('auth.forgot_password')}</h1>
                <p style={{ fontSize: 15, color: 'var(--text-secondary)', marginBottom: 32 }}>Enter your email to receive a reset link.</p>

                {error && (
                  <div style={{ padding: '12px 16px', background: 'rgba(211,47,47,0.08)', border: '1px solid var(--secondary)', color: 'var(--secondary)', marginBottom: 20, fontSize: 14 }}>{error}</div>
                )}

                <form onSubmit={handleSubmit} data-testid="reset-form">
                  <div style={{ marginBottom: 24 }}>
                    <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{t('auth.email')}</label>
                    <input data-testid="reset-email-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required
                      style={{ width: '100%', padding: '12px 14px', border: '1px solid var(--border)', fontSize: 15, outline: 'none', boxSizing: 'border-box' }} />
                  </div>
                  <button type="submit" data-testid="reset-submit-btn" disabled={loading}
                    style={{ width: '100%', padding: '14px', background: 'var(--primary)', color: 'white', fontWeight: 600, fontSize: 15, border: 'none', textTransform: 'uppercase', letterSpacing: '0.05em', opacity: loading ? 0.7 : 1, cursor: 'pointer' }}>
                    {loading ? '...' : 'Send Reset Link'}
                  </button>
                </form>

                <div style={{ marginTop: 24, textAlign: 'center' }}>
                  <Link to="/login" data-testid="back-to-login" style={{ fontSize: 14, color: 'var(--primary)', fontWeight: 600 }}>&larr; {t('auth.login')}</Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
